import React, { PropsWithChildren } from 'react';
import { FieldArray } from 'react-final-form-arrays';

import { EmailRecipientsArray } from 'Components/FormFields';
import { InteractExtraValues } from 'Interfaces/Document';

interface SelectActionFormSignDocumentPageProps {
  onSetExtraValues: (values: InteractExtraValues) => void;
}

const SelectActionFormSignDocumentPage = ({
  children,
  onSetExtraValues,
}: PropsWithChildren<SelectActionFormSignDocumentPageProps>) => {
  return (
    <div className="selectActionForm__emailField">
      <p className="selectActionForm__emailField-title selectActionForm__emailField-title--expanded">
        Add Viewers
      </p>
      <FieldArray
        name="recipients"
        label={null}
        component={EmailRecipientsArray}
        isItemsDeletable
        handleSetRecipientsValues={onSetExtraValues}
      />
      {children}
    </div>
  );
};

export default SelectActionFormSignDocumentPage;
